// extracted by mini-css-extract-plugin
module.exports = {"subtext":"BranchBasicInformation_subtext___C6tk"};